var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderContent',{attrs:{"header":"จัดการรูปภาพหน้าเว็บไซต์","img_header":_vm.header_image,"link_back":"content"}}),_c('MenuContentManageImage'),_c('ContentManageImportCountryList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }